import { Ic_close } from "../../helpers/ImagesCache";
import { useEffect } from "react";
import { isMobile, isTablet } from "react-device-detect";

export const FloatingDialog = ({
  isOpen,
  noBackground,
  children,
  onClose,
  headerText,
  headerIcon,
  variant,
}) => {
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
      document.body.style.touchAction = "none"; // optional: for better mobile behavior
    } else {
      document.body.style.overflow = "";
      document.body.style.touchAction = "";
    }

    return () => {
      document.body.style.overflow = "";
      document.body.style.touchAction = "";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 ${
        noBackground ? "" : "bg-[#000b]"
      } z-[10001] flex pointer-events-auto ${
        variant === "bottom" ? "items-end" : "items-center justify-center"
      }`}
    >
      <div
        className={
          variant === "bottom"
            ? "relative bg-white w-full h-[90%] max-h-[90%] rounded-t-xl shadow-lg p-6 flex flex-col"
            : "relative bg-white w-[80%] h-[80%] max-w-[90%] max-h-[90%] rounded-xl shadow-lg p-6 flex flex-col"
        }
      >
        <div className="w-full mb-3 top-8 left-8 z-10 flex items-center gap-2">
          {headerIcon && <img src={headerIcon} width={40} height={40} />}
          {headerText && (
            <span
              className={`${
                isTablet ? "text-2xl" : "text-xl"
              } font-bold text-[#000e]`}
            >
              {headerText}
            </span>
          )}
          {onClose && (
            <button className="absolute top-4 right-4 z-10" onClick={onClose}>
              <img src={Ic_close} alt="close" />
            </button>
          )}
        </div>
        <div className="flex flex-1 overflow-auto h-full">{children}</div>
      </div>
    </div>
  );
};
